import { render, staticRenderFns } from "./create-carrier.vue?vue&type=template&id=6bc2f1dc"
import script from "./create-carrier.vue?vue&type=script&lang=js"
export * from "./create-carrier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports